/**
 * Updates the subtotal and totals of all items on cart
 * @param {Object} data - AJAX response from the server
 */
function updateProductsTotalAndSubtotal(data) {
    if (data.productCardsUpdateHtml) {
        if ($('.cc-cart__productItemsContainer').length > 0) {
            if (data.uuid) {
                // manually updating of price, template complete update when they contains isinclude tags is not available due to res.json
                $('.js-item.js-uuid-' + data.uuid + ' .js-ptotal-' + data.uuid).text(data.updatedItem.priceTotal.price);
                if (data.updatedItem.priceTotal.nonAdjustedPrice) {
                    $('.js-item.js-uuid-' + data.uuid + ' .js-ptotal-' + data.uuid + '.js-uptade-ptotal-sales').text(data.updatedItem.priceTotal.nonAdjustedPrice);
                }
                $('.js-item.js-uuid-' + data.uuid + ' .js-item-quantity-' + data.uuid).attr('data-quantity', data.updatedItem.quantity);

                // Update aria-labels for accessibility
                $('.js-item.js-uuid-' + data.uuid + ' .js-accessibility-total-amount-' + data.uuid).attr('aria-label', window.cartAria.totalAmount.label + " " + data.updatedItem.priceTotal.price);
                $('.js-item.js-uuid-' + data.uuid + ' .js-accessibility-total-quantity-' + data.uuid).attr('aria-label', window.cartAria.totalQuantity.label + " " + data.updatedItem.quantity);

                $('.js-item.js-uuid-' + data.uuid + ' .js-analytics-click-product-info-' + data.updatedItem.id).attr('data-quantity', data.updatedItem.quantity);
            } else {
                $('.cc-cart__productItemsContainer').empty().append(data.productCardsUpdateHtml);
            }
        } else {
            $('.cc-product-items-container').empty().append(data.productCardsUpdateHtml);
        }
    }
}
/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            if ($('.js-numofitems').length > 0) {
                $('.js-numofitems').empty().append(data.resources.numberOfItems);
            }
            $('.js-numofitemsv2').empty().append(data.numItems);
            $('.js-numofitems-label').removeClass('d-none');
            if (data.numItems == 1) {
                $('.js-numofitems-label-p').addClass('d-none');
            } else {
                $('.js-numofitems-label-s').addClass('d-none');
            }
            $('.js-minicart-numofitems').empty().append(data.resources.minicartNumberOfItems);
            if (data.numItems > 0) {
                $('.js-minicart-quantity').empty().append(data.numItems);
            } else {
                $('.js-minicart-quantity').empty();
            }
        }

        $('.js-checkout-btn').addClass('disabled');
        // $('.js-checkout-btn').prop('disabled', true);
        $('.js-cart-error').removeClass('d-none');
    } else {
        $('.js-checkout-btn').removeClass('disabled');
        // $('.js-checkout-btn').prop('disabled', false);
        $('.js-cart-error').addClass('d-none');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.js-numofitems').empty().append(data.resources.numberOfItems);
    $('.js-numofitemsv2').empty().append(data.numItems);
    $('.js-numofitems-label').removeClass('d-none');
    if (data.numItems == 1) {
        $('.js-numofitems-label-p').addClass('d-none');
    } else {
        $('.js-numofitems-label-s').addClass('d-none');
    }
    $('.js-grand-total').empty().append(data.totals.grandTotal);
    if (!data.approachingDiscounts.orderDiscount.hasOwnProperty('formatted')) {
        if (!$('.js-order-discount-container').hasClass('d-none')) {
            $('.js-order-discount-container').addClass('d-none');
        }
    } else {
        $('.js-order-discount-container').removeClass('d-none');
    }
    $('.js-order-discount-total').empty().append(data.approachingDiscounts.orderDiscount.formatted);
    if (!data.approachingDiscounts.productDiscount.hasOwnProperty('formatted')) {
        if (!$('.js-product-discount-container').hasClass('d-none')) {
            $('.js-product-discount-container').addClass('d-none');
        }
    } else {
        $('.js-product-discount-container').removeClass('d-none');
    }
    $('.js-product-discount-total').empty().append(data.approachingDiscounts.productDiscount.formatted);
    if (!data.approachingDiscounts.couponDiscount.hasOwnProperty('formatted')) {
        if (!$('.js-coupon-discount-container').hasClass('d-none')) {
            $('.js-coupon-discount-container').addClass('d-none');
        }
    } else {
        $('.js-coupon-discount-container').removeClass('d-none');
    }
    $('.js-coupon-discount-total').empty().append(data.approachingDiscounts.couponDiscount.formatted);
    $('.js-coupon-discount-id').empty().append(data.approachingDiscounts.couponDiscount.couponId);
    $('.js-sub-total').empty().append(data.totals.subTotal);

    if (data.numItems > 0) {
        $('.js-minicart-quantity').empty().append(data.numItems);
    } else {
        $('.js-minicart-quantity').empty();
    }
    $('.js-minicart-numofitems').empty().append(data.resources.minicartNumberOfItems);
    if (data.miniCartSide.length > 0) {
        $('.js-minicart-pcard').empty().append(data.miniCartSide);
    }
}

module.exports = {
    updateProductsTotalAndSubtotal: updateProductsTotalAndSubtotal,
    validateBasket: validateBasket,
    updateCartTotals: updateCartTotals
};
